import * as Sentry from '@sentry/browser';
import 'normalize.css/normalize.css';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';

// React 19 removed ReactDOM.findDOMNode, which react-transition-group@2
// (pulled in by react-loading-overlay) still calls. Re-add a minimal shim
// so the loading overlay's transitions don't crash.
if (typeof (ReactDOM as any).findDOMNode !== 'function') {
  (ReactDOM as any).findDOMNode = (instance: any): Element | Text | null => {
    if (instance == null) return null;
    if (instance.nodeType) return instance; // already a DOM node
    let node = instance._reactInternals ?? instance._reactInternalFiber;
    while (node) {
      if (node.stateNode && node.stateNode.nodeType) return node.stateNode;
      node = node.child;
    }
    return null;
  };
}

Sentry.init({ dsn: 'https://b84e3a8b326c4ee9912bef173d408550@sentry.io/1888268' });

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
